import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  IonCard,
  IonCardContent,
  IonItem,
  IonText,
  IonList,
} from "@ionic/react";
import { getTeamRoundScore } from "services/util";

interface props {
  teams: any;
  progress: any;
}

const RoundResults: React.FC<props> = ({ teams, progress }) => {
  const [teamStatus, setTeamStatus] = useState<any>([]);

  const score = (team: any) => {
    return getTeamRoundScore(team, progress.round);
  };

  // const sortByTeamName = (a: any, b: any) => {
  //   const nameA = a.teamName.toUpperCase(); // ignore upper and lowercase
  //   const nameB = b.teamName.toUpperCase();
  //   if (nameA < nameB) {
  //     return -1;
  //   }
  //   if (nameA > nameB) {
  //     return 1;
  //   }

  //   return 0;
  // };

  // console.log("here");

  useEffect(() => {
    setTeamStatus(
      teams
        .map((team: any) => {
          return {
            teamName: team.teamName,
            score: score(team),
          };
        })
        .sort((a: any, b: any) => b.score - a.score)
    );
    //eslint-disable-next-line
  }, [teams]);

  return (
    <IonCard style={{ maxWidth: "600px" }}>
      <IonCardContent>
        <IonList>
          {teamStatus.map((team: any, i: any) => {
            return (
              <IonItem key={i} lines="full">
                <IonText
                  slot="start"
                  style={{ width: "100%", maxWidth: "70%" }}
                >
                  {team.teamName}
                </IonText>

                <IonText>{team.score === 0 ? "0" : team.score}</IonText>
              </IonItem>
            );
          })}
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};
const mapStateToProps = (state: any) => ({
  quizData: state.quiz,
  teams: state.teams.teams,
  progress: state.quiz.progress,
});

export default connect(mapStateToProps, {})(RoundResults);
